export default "__VITE_ASSET__adbb2b71__"